<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { usePvpCardGameStore } from '../services/gameService';
import { formatNumberWithCommas } from '@/utils';
import Card from './Card.vue';
import type { Dictionary } from 'lodash';
import SoulCurrency from './SoulCurrency.vue';
import { nextTick } from 'vue';
import { useUserStore } from '@/stores/modules/user';
import AspectRatio from './AspectRatio.vue';
import CardInfo from './CardInfo.vue';


const pvpCardGameStore = usePvpCardGameStore()
const userStore = useUserStore()
const showResult = ref(false)
class BuyResult {
  coin = 0
  diamond = 0
  cards: Dictionary<number> = {}
}
const buyResult = ref<BuyResult>(new BuyResult())
const cardPackData = computed(() => {
  return Object.entries(buyResult.value.cards).map(([id, count]) => ({
    ...pvpCardGameStore.getDetailById(Number(id)),
    count
  }))
})
function handleCloseResult() {
  showResult.value = false
}
async function handleOpenResult(result: Partial<BuyResult>) {
  buyResult.value = new BuyResult()
  result.coin && (buyResult.value.coin = result.coin)
  result.diamond && (buyResult.value.diamond = result.diamond)
  result.cards && (buyResult.value.cards = result.cards)
  showResult.value = true
  await nextTick()
  cardPackData.value.forEach(item => {
    if (item.id > 4000) {
      pvpCardGameStore.sendNotice(`恭喜玩家[${userStore.nickname}]获得${item.count}张${item.name}！`)
    }
  })
}
defineExpose({
  handleOpenResult,
  handleCloseResult
})
</script>
<template>
  <el-dialog v-model="showResult" width="100%" style="max-width: 500px">
    <div class="receive-item">
      <h2>恭喜获得</h2>
      <div class="receive-detail">
        <p v-show="buyResult.coin">
          <SoulCurrency type="dust" size="18px" /> 魂尘：{{ formatNumberWithCommas(buyResult.coin) }}
        </p>
        <p v-show="buyResult.diamond">
          <SoulCurrency type="quartz" size="18px" /> 魂晶：{{ formatNumberWithCommas(buyResult.diamond) }}
        </p>
      </div>
      <div class="btn-wrap" style="max-height: 50vh; overflow: auto">
        <el-row :gutter="10">
          <el-col :span="12" v-for="item of cardPackData" :key="item.id">
            <el-popover placement="bottom" width="300px" trigger="click">
              <template #reference>
                <CommonBtn size="small">
                  <span style="display:flex;">
                    <span :class="item.grade">
                      {{ item.name }}
                    </span>
                    <span>*{{ item.count }}</span>
                  </span>
                </CommonBtn>
              </template>
              <div style="width:100%;">
                <CardInfo :card="item" :upgradeable="false" />
              </div>
            </el-popover>
          </el-col>
        </el-row>
      </div>
    </div>
    <template #footer>
      <p style="text-align: center">
        <el-button size="small" @click="handleCloseResult">
          知道了
        </el-button>
      </p>
    </template>
  </el-dialog>
</template>
<style lang="scss" scoped>
.receive-item {
  .receive-detail {
    p {
      margin: 5px 0;
    }
  }

  .btn-wrap {
    &>div {
      justify-content: unset;
    }

    .common-btn-wrap {
      margin-bottom: 10px;
    }

    :deep() {

      .el-button:focus,
      .el-button:hover {
        background-color: unset;
      }
    }
  }
}
</style>